import { useAuth } from '@/context/auth-context'
import { Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

interface RequireAuthProps {
  children: React.ReactNode
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { user, loading, token } = useAuth()
  const location = useLocation()
  const isAuthenticated = !!user && !!token
  
  // Also check localStorage for token as a backup
  const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('auth_token')
  const forceLogout = localStorage.getItem('force_logout') === 'true'
  
  console.log('RequireAuth check:', { isAuthenticated, hasToken, loading, path: location.pathname, user, token })
  
  // Check for force_logout flag on every route change
  useEffect(() => {
    if (forceLogout) {
      console.log('Force logout flag detected, user should be redirected to login')
    }
  }, [forceLogout, location])

  // If still loading, show a loading indicator
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
        <span className="ml-2">Loading authentication...</span>
      </div>
    )
  }

  // Check both the auth context and localStorage to ensure we're truly authenticated
  if (!isAuthenticated || forceLogout) {
    console.log('Not authenticated, redirecting to login page')
    // Save the current location so we can redirect back after login
    // This allows users to be redirected to the page they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}